'use client';
import {
  assertIsLocale,
  overwriteGetLocale,
  type Locale,
} from '@bells/i18n/runtime';
import Cookies from 'js-cookie';
import { useMemo, type PropsWithChildren } from 'react';
import { LanguageCookieName } from './i18n-constant';
import { LanguageContext, type LanguageContextProps } from './i18n-context';

export const I18nClientProvider = ({
  language,
  children,
  withCookie = true,
}: PropsWithChildren<{ language: Locale; withCookie: boolean }>) => {
  overwriteGetLocale(() => {
    return assertIsLocale(language);
  });

  const languageConfig: LanguageContextProps = useMemo(() => {
    return {
      language: language,
      setLanguage: (lang) => {
        if (withCookie) {
          Cookies.set(LanguageCookieName, lang);
          window.location.reload();
        }
      },
    };
  }, [language]);

  return (
    <LanguageContext.Provider value={languageConfig}>
      {children}
    </LanguageContext.Provider>
  );
};
